// Self-hosted initials avatars.
//
// Replaces third-party avatar services (ui-avatars.com, via.placeholder.com)
// with an inline SVG data URI generated locally. No network requests, no
// third-party dependency. Each user gets a deterministic on-brand colour based
// on their name/id so their avatar stays consistent across the app.

// On-brand background/foreground pairs (sage, mauve, sand families from the
// Mums Connect palette in client/tailwind.config.js).
const AVATAR_COLORS = [
  { bg: '#d4e8df', fg: '#3f5249' },
  { bg: '#cbe2d7', fg: '#4f645b' },
  { bg: '#f5d8da', fg: '#6a4549' },
  { bg: '#f0cdd0', fg: '#7d5458' },
  { bg: '#efe4d2', fg: '#574d3e' },
  { bg: '#e7dcc6', fg: '#685e4f' },
];

function hashString(value) {
  const text = String(value || '');
  let hash = 0;
  for (let i = 0; i < text.length; i += 1) {
    hash = ((hash << 5) - hash) + text.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
}

// Up to two alphanumeric initials from a name (e.g. "Jane Doe" -> "JD").
function getInitials(name) {
  const parts = String(name || '')
    .trim()
    .split(/\s+/)
    .map((part) => part.replace(/[^A-Za-z0-9]/g, ''))
    .filter(Boolean);

  if (!parts.length) return 'M';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

// Returns a data-URI SVG avatar showing the person's initials on a deterministic
// brand-coloured background. `seed` keeps the colour stable (e.g. pass a user id);
// it falls back to the name when omitted.
export function initialsAvatar(name, seed) {
  const initials = getInitials(name);
  const color = AVATAR_COLORS[hashString(seed || name || 'mum') % AVATAR_COLORS.length];
  const svg =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128">' +
    `<rect width="128" height="128" fill="${color.bg}"/>` +
    `<text x="64" y="64" dy="0.35em" text-anchor="middle" ` +
    `font-family="Plus Jakarta Sans, Segoe UI, Helvetica, Arial, sans-serif" ` +
    `font-size="52" font-weight="600" fill="${color.fg}">${initials}</text>` +
    '</svg>';
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}

export default initialsAvatar;
